import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/fieldReportTypes/reports/${string | ':code'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/fieldReportTypes/reports/:code`;

export const URL = (code: string): RouteDefinition =>
	`${baseRoute}/fieldReportTypes/reports/${code}`;
